export default __webpack_public_path__ + "static/media/sg-dropdown.be90db61.webp";